module.exports = __webpack_public_path__ + "img/SalesRevenue.1f2468e9.svg";